import { useEffect, useState } from "react";

/**
 * true unterhalb der Handy-Grenze (640 px, Tailwind `sm`). Aus `pages/calendar.tsx` hierher gezogen
 * (Entscheidung 8, Handy-Mockup 26.09.2026): jede breite Liste zeigt darunter Karten statt Tabelle —
 * und rendert dann NUR die Karten, damit bei 1.214 Katalogzeilen nicht beides im Speicher liegt.
 */
export function useNarrowViewport(query = "(max-width: 640px)"): boolean {
  const [narrow, setNarrow] = useState(() => typeof window !== "undefined" && !!window.matchMedia?.(query).matches);
  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return;
    const apply = () => setNarrow(mq.matches);
    apply();
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, [query]);
  return narrow;
}
